import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  useMediaQuery,
  Button,
  Backdrop,
  LinearProgress,
  Box,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import theme from "../../theme/theme";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

interface HeaderProps {
  sidebarOpen: boolean;
  toggleSidebar: () => void;
}

const DashboardHeader: React.FC<HeaderProps> = ({
  sidebarOpen,
  toggleSidebar,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const handleLogout = () => {
    setLoading(true);
    localStorage.removeItem("jwtToken");
    localStorage.removeItem("role");
    localStorage.removeItem("email");
    localStorage.removeItem("businessName");
    localStorage.removeItem("colorHex");
    setTimeout(() => {
      setLoading(false);
      navigate("/login-carrier");
    }, 1000);
  };
  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: isMobile
          ? (theme) => theme.zIndex.drawer - 1
          : (theme) => theme.zIndex.drawer + 1,
        ml: sidebarOpen ? "240px" : 0,
        width: isMobile ? "100%" : sidebarOpen ? "calc(100% - 240px)" : "100%",
        background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
        transition: (theme) =>
          theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
      }}
    >
      {loading && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
          onClick={() => {
            setLoading(true);
          }}
        >
          <Box sx={{ width: "50%" }}>
            <LinearProgress />
            <Typography
              fontSize={16}
              fontWeight={500}
              textAlign="center"
              mt={1}
            >
              {"Logging out..."}
            </Typography>
          </Box>
        </Backdrop>
      )}
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={toggleSidebar}
          sx={{ mr: 2 }}
        >
          <MenuIcon />
        </IconButton>
        <Typography variant="h6" noWrap component="div">
          Dashboard
        </Typography>
        <Button
          color="primary"
          onClick={handleLogout}
          sx={{
            marginLeft: "auto",
            padding: isMobile ? "5px 15px" : "10px 20px",
            backgroundColor: theme.palette.primary.main,
            color: "#FFFFFF",
            borderRadius: "8px",
            fontWeight: "bold",
            fontSize: "16px",
            transition:
              "transform 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease",
            "&:hover": {
              backgroundColor: theme.palette.primary.dark,
              transform: "scale(1.05)",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            },
            "&:active": {
              transform: "scale(0.98)",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
            },
          }}
        >
          Logout
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default DashboardHeader;
